import React from 'react'
import styled from 'styled-components'

export const StyledComponent = styled(({ isViewAs, ...rest }) => <div {...rest} />)`
  display: block;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: ${p => p.isViewAs ? '#FF7A24' : '#1A5265'};
  font-size: 12px;
  line-height: 25px;
  font-weight: 400;
  text-align: center;

  color: ${props => props.theme.cWhite};

  @media (min-width: ${p => p.theme.tabletSize}) {
    font-size: 16px;
    line-height: 40px;
    width: 40px;
    height: 40px;
  }
`

const _UserAvatarDummy_styled = (props) => <StyledComponent {...props} />
_UserAvatarDummy_styled.propTypes = {}
_UserAvatarDummy_styled.className = StyledComponent

export default _UserAvatarDummy_styled

